var React = require('react');

function IconMenu (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 0V4.35897H34V0H0ZM0 11.3333V15.6923H34V11.3333H0ZM0 22.6667V27.0256H34V22.6667H0Z"}));
}

IconMenu.defaultProps = {"width":"34","height":"28","viewBox":"0 0 34 28"};

module.exports = IconMenu;

IconMenu.default = IconMenu;
